import LoadingPlans from "./LoadingPlans";

export default LoadingPlans;